import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { ShowcaseCollectionCard } from 'C4';
import { baseAppId } from 'settings';

export default class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      showcaseCollection: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  init() {
    const showcaseCollection = this.props.stands;
    const { category } = this.props;
    const params = new URLSearchParams(window.location.search);
    const colId = params.get('id');

    const startingValues = Object.keys(showcaseCollection).map(() => ({
      data: 0,
      pos: 20,
    }));

    this.setState({
      showcaseCollection: (
        <StaggeredMotion
          defaultStyles={startingValues}
          styles={prevInterpolatedStyles =>
            prevInterpolatedStyles.map((_, i) =>
              (i === 0
                ? {
                    data: spring(1, { stiffness: 320, damping: 28 }),
                    pos: spring(0, { stiffness: 320, damping: 28 }),
                  }
                : {
                    data: spring(prevInterpolatedStyles[i - 1].data, {
                      stiffness: 320,
                      damping: 28,
                    }),
                    pos: spring(prevInterpolatedStyles[i - 1].pos, {
                      stiffness: 320,
                      damping: 28,
                    }),
                  }))
          }
        >
          {styles => (
            <React.Fragment>
              {showcaseCollection.map((showcase, i) => {
                const {
                  title,
                  icon,
                  type,
                  id,
                  company_id,
                  exhibition_id,
                  description,
                } = showcase;

                let currentCountry = showcaseCollection[i].country;
                let previousCountry = '';
                if (i !== 0) {
                  previousCountry = showcaseCollection[i - 1].country;
                  currentCountry = showcaseCollection[i].country;
                }

                const style = {
                  opacity: `${styles[i].data}`,
                  transform: `translateY(${styles[i].pos}%)`,
                };

                if (!title) {
                  return;
                }

                return (
                  <React.Fragment>
                    <div
                      key={id}
                      className="ShowcaseCollectionCard__Animated"
                      style={style}
                    >
                      <ShowcaseCollectionCard
                        appId={baseAppId}
                        key={id}
                        index={i}
                        image={icon}
                        subtitle={description}
                        title={title}
                        type={type}
                        url={`/main/hotel-showroom/showcase-collection/${category}/${company_id}?id=${exhibition_id}`}
                        itemID={company_id}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          )}
        </StaggeredMotion>
      ),
    });
  }

  render() {
    return (
      <div className="showcaseCollection__Grid">
        {this.state.showcaseCollection}
        <style>{'\
        .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } '}
        </style>
      </div>
    );
  }
}
